import Base64Image from 'component/Base64Image'
import styled from 'styled-components'
import themeAssetloadingSquareLoadingSvg from '@theme/loading/square-loading.svg'

export const AdImage = styled(Base64Image).attrs({
  placeholder: themeAssetloadingSquareLoadingSvg,
  source: 'picture',
  aspectRatio: 374 / 94,
})`
  width: 100%;
  border-radius: 0.2564rem;
`
